module.exports = "@charset \"UTF-8\";\n.blue-line {\n  width: 100%;\n  /* Abarca todo el ancho disponible */\n  border: none;\n  /* Quita el borde predeterminado */\n  height: 4px;\n  /* Ajusta el grosor de la línea */\n  background-color: rgba(14, 14, 107, 0.753);\n  /* Color de la línea */\n  margin-top: 10px;\n  /* Espacio superior */\n  margin-bottom: 10px;\n  /* Espacio inferior */ }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-imports-basket/master-imports-basket.component.scss
// module id = ./src/app/master/master-imports-basket/master-imports-basket.component.scss
// module chunks = main